// extracted by mini-css-extract-plugin
export default {"header":"EnfantsAmbassadeursHeader_header__UB5oc","logo":"EnfantsAmbassadeursHeader_logo__-Pglb"};